import { useContext } from "react";

import { GridLayoutContext, type GridLayoutContextValue } from "./_context";

export function useGridLayoutContext(): null | GridLayoutContextValue {
	return useContext(GridLayoutContext);
}
